module.exports = __webpack_public_path__ + "static/reports-849de7b59f04b1c19f68d5c25eaebda8.png";